import React from 'react';

import Section from 'react-scale/components/elements/section';
import CTA from 'react-scale/components/tailwind/CTA';
import SubscribeModal from 'react-scale/components/website/big/main/SubscribeModal';
import Atv from 'react-scale/components/elements/atv';

import { mq } from 'react-scale/components/website/big/Themes';

const GetStarted = ({
  children,
  title,
  titleWidth,
  text,
  datasetName,
  background,
  cta,
  subscribeModal
}) => (
  <Section container={false}>
    <div className="text-white get-started">
      <div className="container">
        <div className="grid items-center md:grid-cols-2 md:gap-x-10">
          <div>
            <div className="image-wrapper">
              <div className="atv-wrapper">
                <div className="atv-position">
                  <Atv
                    layers={[
                      `/static/img/website/open-datasets/${datasetName}/${datasetName}-back.svg`,
                      `/static/img/website/open-datasets/${datasetName}/${datasetName}-front.svg`
                    ].filter(layer => layer !== undefined)}
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="content">
              <div className="title">
                <h2 className="mb-4 text-2xl">{title}</h2>
              </div>
              {children}
              {text && (
                <>
                  {text.map(content => (
                    <p className="mb-2 text-lg">{content}</p>
                  ))}
                </>
              )}
              {cta && <CTA cta={cta} />}
              {subscribeModal && (
                <>
                  <p>{subscribeModal.subtitle.text}</p>
                  <SubscribeModal
                    campaign={subscribeModal.campaign}
                    formContainerCN="get-started-hubspot-subscribe"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    <style jsx>{`
      .get-started {
        position: relative;
        margin: 0 calc(var(--container-padding) * -1);
      }
      @media (min-width: ${mq.md}) {
        .get-started {
          margin: 0;
        }
      }
      @media (min-width: ${mq.lg}) {
        .get-started:before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 60%;
          background: ${background};
          z-index: 1;
        }
      }
      .get-started .content {
        text-align: center;
      }
      @media (min-width: ${mq.lg}) {
        .get-started .content {
          text-align: left;
        }
      }
      @media (min-width: ${mq.lg}) {
        .get-started .title {
          max-width: ${titleWidth.lg};
        }
      }
      @media (min-width: 2000px) {
        .get-started .title {
          max-width: ${titleWidth.xl};
        }
      }
      .get-started .image-wrapper {
        background: ${background};
        margin: 2rem 0;
        padding: calc(2rem * 3);
        position: relative;
        z-index: 2;
      }
      @media (min-width: ${mq.md}) {
        .get-started .image-wrapper {
          padding: calc(2rem * 4);
        }
      }
      @media (min-width: ${mq.lg}) {
        .get-started .image-wrapper {
          padding: calc(2rem * 2);
          margin: 0;
        }
      }
      .get-started .image-wrapper .atv-wrapper {
        width: 100%;
        position: relative;
        padding-bottom: 134%;
      }
      .get-started .image-wrapper .atv-position {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    `}</style>
  </Section>
);

GetStarted.defaultProps = {
  children: null,
  text: null,
  cta: null,
  subscribeModal: null,
  titleWidth: {
    xl: 'none',
    lg: 'none'
  }
};

export default GetStarted;
